import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from 'mui-modal-provider';

import { Button } from '../../../common/button';
import { Icon, IconTypes } from '../../../common/icon';
import { BarcodeModal } from './barcode-modal';
import { IBarcodeAction } from './barcode.models';

export const BarcodeAction = ({ isLabelHidden }: IBarcodeAction): JSX.Element => {
  const { showModal } = useModal();

  const handleOpenModalButtonClick = useCallback(() => {
    showModal(BarcodeModal, {});
  }, [showModal]);

  return (
    <Button
      color="info"
      startIcon={<Icon type={IconTypes.barCode} />}
      hideText={isLabelHidden}
      onClick={handleOpenModalButtonClick}
      labelClassName="normal"
      underline
    >
      <FormattedMessage id="header.myBarcode" />
    </Button>
  );
};
